export let AffinityGroupLayoutJSON = [
  {
    name: "Details",
    child: [
      {
        child: [
          {
            child: [
              {
                child: [
                  {
                    parentid: "1717412292824-col-1",
                    elementid: "1717412302140",
                    elementtype: "textfield",
                  },
                ],
                colpos: 1,
                parentid: "1717412292824-columns",
                elementid: "1717412292824-col-1",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [
                  {
                    parentid: "1717412292824-col-2",
                    elementid: "1717412308306",
                    elementtype: "customSelect",
                  },
                ],
                colpos: 2,
                parentid: "1717412292824-columns",
                elementid: "1717412292824-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
            ],
            colsize: 2,
            parentid: "1717412274041-fieldset-body",
            elementid: "1717412292824",
            elementtype: "columns",
          },
          {
            child: [
              {
                child: [
                  {
                    parentid: "1717412297658-col-1",
                    elementid: "1717412315194",
                    elementtype: "customSelect",
                  },
                  {
                    parentid: "1717412297658-col-1",
                    elementid: "1717412322677",
                    elementtype: "textfield",
                  },
                ],
                colpos: 1,
                parentid: "1717412297658-columns",
                elementid: "1717412297658-col-1",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [
                  {
                    parentid: "1717412297658-col-1",
                    elementid: "1717412308300",
                    elementtype: "textfield",
                  },
                ],
                colpos: 1,
                parentid: "1717412297658-columns",
                elementid: "1717412297658-col-1",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [],
                colpos: 2,
                parentid: "1717412297658-columns",
                elementid: "1717412297658-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
            ],
            colsize: 2,
            parentid: "1717412274041-fieldset-body",
            elementid: "1717412297658",
            elementtype: "columns",
          },
        ],
        parentid: "section-1716786817440-form",
        elementid: "1717412274041",
        elementtype: "fieldset",
      },
      {
        child: [
          {
            child: [
              {
                child: [
                  {
                    parentid: "1717412338444-col-1",
                    elementid: "1717412375477",
                    elementtype: "textfield",
                  },
                ],
                colpos: 1,
                parentid: "1717412338444-columns",
                elementid: "1717412338444-col-1",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [
                  {
                    parentid: "1717412338444-col-2",
                    elementid: "1717412387761",
                    elementtype: "email",
                  },
                ],
                colpos: 2,
                parentid: "1717412338444-columns",
                elementid: "1717412338444-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
            ],
            colsize: 2,
            parentid: "1717412322677-fieldset-body",
            elementid: "1717412338444",
            elementtype: "columns",
          },
          {
            child: [
              {
                child: [
                  {
                    parentid: "1717412346075-col-1",
                    elementid: "1717412405877",
                    elementtype: "phoneNumber",
                  },
                ],
                colpos: 1,
                parentid: "1717412346075-columns",
                elementid: "1717412346075-col-1",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [
                  {
                    parentid: "1717412346075-col-2",
                    elementid: "1717412412343",
                    elementtype: "textfield",
                  },
                ],
                colpos: 2,
                parentid: "1717412346075-columns",
                elementid: "1717412346075-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
            ],
            colsize: 2,
            parentid: "1717412322677-fieldset-body",
            elementid: "1717412346075",
            elementtype: "columns",
          },
          {
            child: [
              {
                child: [
                  {
                    parentid: "1717412351926-col-1",
                    elementid: "1717412415059",
                    elementtype: "textfield",
                  },
                ],
                colpos: 1,
                parentid: "1717412351926-columns",
                elementid: "1717412351926-col-1",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [],
                colpos: 2,
                parentid: "1717412351926-columns",
                elementid: "1717412351926-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
            ],
            colsize: 2,
            parentid: "1717412322677-fieldset-body",
            elementid: "1717412351926",
            elementtype: "columns",
          },
        ],
        parentid: "section-1716786817440-form",
        elementid: "1717412322677",
        elementtype: "fieldset",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1716786817440",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
